'use client'

import api from "@/util/api"
import { MutableRefObject, useContext, useEffect, useRef, useState } from "react"
import Lottie from "react-lottie-player"
import loadingJson from "@/public/media/load_data.json"
import PageTabType2, { PageTabType } from "@/components/etc/pageTabType2"
import { useRouter } from "next/navigation"
import SectionTitle from "@/components/etc/section_title"
import { DeviceContext } from "@/context/deviceContext"
import SectionTab from "@/components/etc/section_tab"
import { useLocale, useTranslations } from "next-intl"
import { en_livescoreData } from "@/lib/en_livescoreData"
import { ko_livescoreData } from "@/lib/ko_livescoreData"

interface Props {
    type?: string;

    setshowSpots?: React.Dispatch<React.SetStateAction<boolean>>;
    setshowScore?: React.Dispatch<React.SetStateAction<boolean>>;
    showSpots?: boolean,
    showScore?: boolean,
    positionTopRef?: MutableRefObject<boolean>;
    setPositionTopFlag?: (value: boolean) => void;
}
interface SportsObject {
    sports_type: number;
    sports_type_label: string;
    sports_type_name: string;
    url: string;
}

export default function LiveScoreComponent({ type, setshowSpots, setshowScore, showSpots, showScore, positionTopRef, setPositionTopFlag }: Props) {

    const { mobileMode } = useContext(DeviceContext)
    const locale = useLocale()
    const host = window.location.protocol + "//" + window.location.hostname + (process.env.NODE_ENV === "development" ? ":8000" : "")
    // const host = window.location.protocol + "//" + window.location.hostname + ":8000"
    const [iframePath, setiFramePath] = useState<string | undefined>(`${host}/event`);
    const [iframePath2, setiFramePath2] = useState<string | undefined>(`${host}/event`);

    const [pageTab, setPageTab] = useState<PageTabType[]>([])
    const [pageSubTab, setPageSubTab] = useState<PageTabType[]>([])

    const [loading, setLoading] = useState<boolean>(true)
    const router = useRouter()
    const [loadFrame, setLoadFrame] = useState<boolean>(false)

    const [iframeKey, setIframeKey] = useState(String(Date.now()));

    const [dataHeight, setdataHeight] = useState<number>(300)

    /**
     * ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●
     * 
     *    프록시 막히면 아래값만 true로 변경하고 배포하세여
     *      페이지 준비중 이미지 띄워놨습니다.
     * 
     * ●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●●
     */
    const [isWating, setIsWating] = useState<boolean>(false)



    function replaceWidth(url: string, newWidth: number) {
        return url.replace(/(width=)\d+/, `$1${newWidth}`);
    }

    function fetchData() {
        setLoading(true)
        // const apiUrl = `/api/iframe/score/` + (type ?`?type=${type}`:"")
        if (locale == 'ko') {
            // 7M 사이트로 변경으로 api 안타고 미리 저장된 url 사용
            const topTabs: PageTabType[] = ko_livescoreData.map((item, idx) => ({
                id: item.sports_type,
                title: item.sports_type_name,
                url: item.url,
                side_url: item.side_url,
                sports_type_label: item.sports_type_label,
                sports_type_name: item.sports_type_name,
                sports_type: item.sports_type,
            }));
            setPageTab(topTabs);
            setLoading(false)
            // const apiUrl = `/api/iframe/score/`
            // api(apiUrl)
            //     .then(res => res.json())
            //     .then(({ data }) => {
            //         // const objects = data.objects;

            //         const objects: SportsObject[] = data?.objects ?? [];


            //         /* ********************************* */

            //         const topTabs: PageTabType[] = objects.map((item, idx) => ({
            //             id: item.sports_type,
            //             title: item.sports_type_name,
            //             url: item.url,
            //             sports_type_label: item.sports_type_label,
            //             sports_type_name: item.sports_type_name,
            //             sports_type: item.sports_type,
            //         }));
            //         setPageTab(topTabs);

            //         /* ********************************* */


            //         // setiFramePath(`${host}${data.objects['축구'][0].url}`)
            //         setLoading(false)

            //     })
            //     .catch(err => {
            //         console.error("fetchData error:", err);
            //         setLoading(false)
            //     });
        } else {
            const topTabs: PageTabType[] = en_livescoreData.map((item, idx) => ({
                id: item.sports_type,
                title: item.sports_type_name,
                url: item.url,
                side_url: item.side_url,
                sports_type_label: item.sports_type_label,
                sports_type_name: item.sports_type_name,
                sports_type: item.sports_type,
            }));
            setPageTab(topTabs);
            setLoading(false)
        }
    }

    const handleMain = (id: number, obj: PageTabType) => {
        //console.log("메인 탭 클릭:", id, obj);

        if (iframePath !== host + obj.url) {
            // if (locale == 'ko') {
            //     setiFramePath(host + obj.url);
            // } else {
                let localeUrl = obj.url
                if(localeUrl && typeof localeUrl == "string"){
                    if (type == "small" && obj.sports_type_name == "축구" && obj.side_url) {
                        localeUrl = obj.side_url;
                    }

                    if (mobileMode) {
                        localeUrl = replaceWidth(localeUrl, window.innerWidth)
                    }

                    setiFramePath(localeUrl);
                }
            // }
        } else {
            setLoading(false)
        }


        // if(iframePath != (host + obj.url)) {
        //     setiFramePath("")
        //     setTimeout(() => {
        //         setiFramePath(host + obj.url)
        //     }, 100);
        // }else{
        //     setLoading(false)
        // }

    };

    useEffect(() => {
        if (!isWating) {
            setLoading(true)
            fetchData()
        } else {
            setLoading(false)
        }
    }, [])

    const boxRef = useRef<HTMLDivElement>(null);
    useEffect(() => {
        if (!iframePath) return;
        setiFramePath2(iframePath);
        setIframeKey(String(Date.now()));
    }, [iframePath]);

    useEffect(() => {
        function handleMessage(event: MessageEvent) {
            if (event.data?.type === "height_score") {
                //console.log("***height score", event.data);

                const iframes = document.querySelectorAll<HTMLIFrameElement>(".sp-ifram");
                iframes.forEach((iframe) => {
                    // src 매칭해서 해당 프레임만 높이 조정
                    //console.log("***",iframe.src === event.data.target)
                    if (iframe.src === event.data.target && event.data.height < 1000) {
                        iframe.style.height = event.data.height + "px";
                        setdataHeight(event.data.height)
                    }
                });
            }
        }

        window.addEventListener("message", handleMessage);

        return () => {
            window.removeEventListener("message", handleMessage);
        };
    }, []);




    function afterLoadIframe() {
        // console.log("여기22", positionTopRef?.current);
        if (type && positionTopRef?.current) {
            setTimeout(() => {
                const wrapper = document.querySelector('.iframeStickyWrapper');
                if (wrapper) {
                    const rect = wrapper.getBoundingClientRect();
                    const wrapperTop = rect.top + window.scrollY;
                    const HEADER_HEIGHT = 50;
                    window.scrollTo({
                        top: wrapperTop - HEADER_HEIGHT
                    });
                }
            }, 100);

        }
        setLoading(false);
        setTimeout(() => {
            setPositionTopFlag?.(false)
        }, 200);
    }

    const t = useTranslations('PageTitle')

    return (
        <>

            {type ?
                <>
                    <div ref={boxRef}
                        className={`${mobileMode ? "stickyBox" : ""}`}>
                        <SectionTab setshowSpots={setshowSpots}
                            setshowScore={setshowScore}
                            showSpots={showSpots}
                            showScore={showScore}
                            setpositionTop={setPositionTopFlag}></SectionTab>
                        <SectionTitle shortCut={`/livescore/`} type="livescore" className={`p-b-8`}>{t.rich('스포츠 b:스코어', { b: (chunks) => <b>{chunks}</b> })}</SectionTitle>
                        <PageTabType2
                            mainTab={pageTab}
                            clickMainTab={handleMain}
                            setLoading={setLoading}
                            type={type}
                            loadFrame={loadFrame}
                            setLoadFrame={setLoadFrame} />
                    </div>
                </>
                :

                <PageTabType2
                    mainTab={pageTab}
                    clickMainTab={handleMain}
                    setLoading={setLoading}
                    type={type}
                    loadFrame={loadFrame}
                    setLoadFrame={setLoadFrame} />
            }



            <div className={`loadingWrapper`} style={{ marginTop: `${type ? "-8px" : 0}` }}>
                {isWating ?
                    <div className={`flex center`}>
                        <img src={`/image/etc/ready_${locale}.png`} />
                    </div>
                    :

                    <iframe src={`${iframePath2}`}
                        width={`100%`}
                        className={`sp-ifram`}
                        key={iframeKey}
                        onLoad={(e) => {
                            afterLoadIframe();
                            // setLoading(false);
                        }}
                        style={{ minHeight: `1000px`, border: "0" }}
                        data-type={type || "full"}
                        data-height={dataHeight}></iframe>
                }

                <div className={`loadingObj ${loading ? "show" : ""}`}>
                    <Lottie loop animationData={loadingJson} play style={{ maxWidth: "400px", margin: "0 auto" }} />
                </div>
            </div>


        </>
    )


}
